export const FEATURE_NAME = '@zerops/zerops/feature/control-plane-dialog';

/**
 * Single recipe source for the unified zcp control plane service.
 * Coding Agent and Cloud IDE are now independent opt-in features on the same recipe.
 */
export const ZCP_RECIPE_SOURCE = 'zeropsio/zcp';

/**
 * Service name prefix for the control plane service. Increments via
 * `getNextServiceName('zcp', existingNames)` when multiple are deployed.
 */
export const ZCP_SERVICE_NAME_PREFIX = 'zcp';
